// exportLabs.ts
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'

export interface CourseTypeRow {
    treatmentCourseTypeName: string
    treatmentCourseTypeNameEn: string
    status: string
    updatedBy: string
    updatedAt: string
}

export interface CourseTypeReport {
    title: string
    statusFilter: string
    rows: CourseTypeRow[]
    t: any
}

export async function exportCourseTypeToExcel(report: CourseTypeReport) {
    // 1) สร้าง workbook + worksheet
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(report.title, {
        pageSetup: { orientation: 'portrait' }
    })
    ws.properties.defaultRowHeight = 20

    // 2) กำหนดความกว้างคอลัมน์ (ไม่กำหนด header)
    ws.columns = [
        { width: 6 },
        { width: 30 },
        { width: 30 },
        { width: 14 },
        { width: 30 },
    ]

    // 3) ลบ header row อัตโนมัติที่ ExcelJS แทรกมาให้
    ws.spliceRows(1, 1)

    let rowIndex = 1

    // 4) เขียน Title (merge A1:D1)
    ws.mergeCells(rowIndex, 1, rowIndex, 5)
    const titleCell = ws.getCell(rowIndex, 1)
    titleCell.value = report.title
    titleCell.font = { size: 16, bold: true }
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' }
    rowIndex += 2

    // 5) เขียน Status Filter (merge A3:D3)
    ws.mergeCells(rowIndex, 1, rowIndex, 5)
    const statusCell = ws.getCell(rowIndex, 1)
    statusCell.value = report.statusFilter
    statusCell.font = { size: 12 }
    statusCell.alignment = { horizontal: 'left', vertical: 'middle' }
    rowIndex += 2

    // 6) สร้าง Header Row ใหม่
    const headers = [
        '#',
        report.t('TREATMENT_COURSE_TYPE.TABLE.CELL.TREATMENT_COURSE_TYPE_NAME'),
        report.t('TREATMENT_COURSE_TYPE.TABLE.CELL.TREATMENT_COURSE_TYPE_NAME_EN'),
        report.t('TREATMENT_COURSE_TYPE.TABLE.CELL.STATUS'),
        report.t('TREATMENT_COURSE_TYPE.TABLE.CELL.UPDATED_BY'),
    ]
    const headerRow = ws.getRow(rowIndex)
    headerRow.values = headers
    headerRow.height = 24
    headerRow.font = { bold: true }
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
    headerRow.eachCell(cell => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
        }
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })
    rowIndex++

    if (!report.rows || report.rows.length === 0) {
        const noDataRow = ws.addRow([report.t('REPORT.TITLE.NO_DATA')])
        ws.mergeCells(noDataRow.number, 1, noDataRow.number, ws.columns.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
        const buf = await wb.xlsx.writeBuffer()
        saveAs(
            new Blob([buf]),
            `${report.title}_${moment().format('YYYYMMDD')}.xlsx`
        )
        return
    }
    // 7) ใส่ข้อมูลแถวต่อไป
    report.rows.forEach((r, i) => {
        const excelRow = ws.getRow(rowIndex + i)
        excelRow.values = [
            i + 1,
            r.treatmentCourseTypeName,
            r.treatmentCourseTypeNameEn,
            r.status,
            `${r.updatedBy} ${r.updatedAt}`
        ]
        excelRow.height = 20

        excelRow.eachCell((cell, col) => {
            // กำหนด border
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            // จัด alignment
            if (col === 2 || col === 3) {
                cell.alignment = { horizontal: 'left', vertical: 'middle' }
            } else {
                cell.alignment = { horizontal: 'center', vertical: 'middle' }
            }
        })
    })

    const buf = await wb.xlsx.writeBuffer()
    saveAs(
        new Blob([buf]),
        `${report.t('TREATMENT_COURSE_TYPE.TITLE')}_${moment().format('YYYYMMDD')}.xlsx`
    )
}
